import React from 'react';
import {graphql} from 'gatsby';
import {ContentTilesFragment} from '@graphql-types';

import * as styles from './contentTiles.module.scss';
import PageSection from '@src/components/PageSection';

const ContentTiles: React.FC<ContentTilesFragment> = props => {
  return (
    <div className={styles.beigeBackground}>
      <PageSection>
        <div className={styles.section}>
          <div
            className={styles.heading}
            dangerouslySetInnerHTML={{__html: props.primary.heading.html}}
          />
          <div className={styles.itemWrapper}>
            {props.items.map((item, i) => (
              <div
                className={styles.item}
                key={i}
                dangerouslySetInnerHTML={{__html: item.content.html}}
              />
            ))}
          </div>
        </div>
      </PageSection>
    </div>
  );
};

export default ContentTiles;

export const query = graphql`
  fragment contentTiles on PrismicPageDataBodyContentTiles {
    id
    slice_type
    primary {
      heading {
        html
      }
    }
    items {
      content {
        html
      }
    }
  }
`;
